import { isEmpty, isNonNullish } from 'remeda'
import { useTheme } from 'styled-components'
import { ArrowDownIcon } from '@velasca/icons/arrow-down'
import { scrollTo } from '@velasca/utils/scroll-to'
import { IconButton } from '../IconButton/IconButton'
import { Container, Picture, ScrollDown } from './PageIntro.styles'
import type { PageIntroProps } from './PageIntro.types'

export const PageIntro = ({
  mediaSources,
  fallbackImage,
  hasShadow = true,
  canScroll = true,
  offsetHeight = 0,
  children,
}: PageIntroProps): JSX.Element => {
  const theme = useTheme()

  return (
    <>
      <Container hasShadow={hasShadow} offsetHeight={offsetHeight}>
        {isNonNullish(fallbackImage) && !isEmpty(fallbackImage) && (
          <Picture
            mediaSources={mediaSources}
            alt={fallbackImage.alt}
            sources={fallbackImage.sources}
            imgSrc={fallbackImage.imgSrc}
          />
        )}

        {children}

        {canScroll && (
          <ScrollDown>
            <IconButton
              iconSize="2rem"
              clickAreaSize="8.2rem"
              color={theme.colors.text.secondary}
              onClick={() => {
                scrollTo('#scrolldown-target', offsetHeight)
              }}
            >
              <ArrowDownIcon />
            </IconButton>
          </ScrollDown>
        )}
      </Container>
      {canScroll && <div id="scrolldown-target"></div>}
    </>
  )
}
